module.exports = __webpack_public_path__ + "vfn-assets/img/viva-cash.a07e3a91.svg";